export { default as ParlorDetailTableVersionContainer } from "./ParlorDetailTableVersionContainer";
